import { tag } from "./tag";
import { time } from './room';

export type ActivityDefinition = {
    _id?: string;
    description: string;
    displayName: string;
    validFrom: Date;
    expiresOn: Date;
    isReservable: boolean;
    trainerIds: string[];
    tag: tag;
    scheduleDefinition: ActivityScheduleDefinition;
    state: ActivityState
}
export enum ActivityState {
    draft = 0,
    approved = 1
}
export type ActivityScheduleDefinition = {
    monday?: ScheduleDefinition,
    tuesday?: ScheduleDefinition,
    wednesday?: ScheduleDefinition,
    thursday?: ScheduleDefinition,
    friday?: ScheduleDefinition,
    saturday?: ScheduleDefinition,
    sunday?: ScheduleDefinition,
}
export type ScheduleDefinition = {
    time: time,
    duration: number,
    capacity: number
}
export type ActivityDefinitionDay = {
    name: string;
    startTime?: time,
    duration?: number,
    capacity?: number,
}
export type ActivitySchedule = {
    _id?: string;
    isReservable: boolean;
    activityDefinitionId?: string;
    date: Date;
    displayName: string;
    description: string;
    duration: number;
    capacity: number;
    trainerIds: string[];
    tag: tag;
    state: ActivityState;
    reservations?: ActivityReservation[],
}

export type ActivityReservation = {
    _id: string;
    activityScheduleId: string;
    sub: string;
    surname: string;
    name: string;
    email: string;
    date: Date;
}

export type day = {
    code: number, name: string
}
export const days: Array<day> = [{ code: 1, name: 'Lunedì' }, { code: 2, name: 'Martedì' }, { code: 3, name: 'Mercoledì' }, { code: 4, name: 'Giovedì' }, { code: 5, name: 'Venerdì' }, { code: 6, name: 'Sabato' }, { code: 0, name: 'Domenica' }];
